<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('my.personal_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="cell-card">
      <div class="cell-row" @click="openHerderImg()">
        <div class="left">{{ $t("setting.avatar") }}</div>
        <div class="right">
          <img
            :src="avatarSrc"
            class="avatar"
            alt=""
            @error="onAvatarError"
          />
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
      <div class="cell-row" @click="toSetName()">
        <div class="left">{{ $t("setting.real_name") }}</div>
        <div class="right">
          <span class="desc">{{
            userInfo.name ? userInfo.name : $t("setting.no_setting")
          }}</span>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
      <div class="cell-row" @click="toSetSex()">
        <div class="left">{{ $t("setting.sex") }}</div>
        <div class="right">
          <span class="desc">{{ sexText }}</span>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
      <div class="cell-row" @click="toSetBank()">
        <div class="left">{{ $t("setting.bank_info") }}</div>
        <div class="right">
          <span class="desc">{{
            isBank ? $t("setting.y_setting") : $t("setting.no_setting")
          }}</span>
          <van-icon name="arrow" color="#c8c9cc" />
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round :style="{ height: '58%' }">
      <div class="avatarbox">
        <div class="title">
          <van-icon name="cross" @click="show = false" />
          <div class="text">{{ $t("setting.choose_avatar") }}</div>
          <div class="btnok" @click="check()">{{ $t("setting.ok") }}</div>
        </div>
        <div class="avatar-list">
          <van-image
            round
            v-for="n in avatarTotal"
            :key="n"
            :class="{ choose: isActive === avatarUrl(n) }"
            :src="avatarUrl(n)"
            @click="select_header_img(avatarUrl(n))"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
const AVATAR_BASE = "/img/head/";
const AVATAR_FALLBACK = "/img/head/1.png";

export default {
  data() {
    return {
      isActive: "",
      show: false,
      isBank: false,
      userInfo: {},
      avatarBroken: false,
    };
  },
  computed: {
    sexText() {
      if (this.userInfo.sex === "1") return this.$t("setting.man");
      if (this.userInfo.sex === "2") return this.$t("setting.female");
      return this.$t("setting.unkown");
    },
    avatarSrc() {
      if (this.avatarBroken) return AVATAR_FALLBACK;
      const src = (this.userInfo.header_img || "").trim();
      if (!src || /zxbuk\.oss-cn-hongkong\.aliyuncs\.com/i.test(src)) {
        return AVATAR_FALLBACK;
      }
      return src;
    },
    avatarTotal() {
      const n = Number(this.$store.getters.getBaseInfo.head_toal);
      return n > 0 ? n : 20;
    },
  },
  methods: {
    avatarUrl(n) {
      return AVATAR_BASE + n + ".png";
    },
    onAvatarError() {
      this.avatarBroken = true;
    },
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({ path: "/Setname" });
    },
    toSetSex() {
      this.$router.push({ path: "/Setsex" });
    },
    toSetBank() {
      this.$router.push({ path: "/Setbank" });
    },
    openHerderImg() {
      this.isActive = this.avatarSrc;
      this.show = true;
    },
    select_header_img(url) {
      this.isActive = url;
    },
    check() {
      if (!this.isActive) {
        this.$toast(this.$t("setting.choose_avatar"));
        return;
      }
      this.$http({
        method: "post",
        data: { header_img: this.isActive },
        url: "user_header_img",
      }).then((res) => {
        if (res.code === 200) {
          this.avatarBroken = false;
          this.getUserInfo();
          this.$toast(res.msg || this.$t("setting.ok"));
          this.show = false;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({ method: "get", url: "user_info" }).then((res) => {
        if (res.code === 200) {
          this.avatarBroken = false;
          this.userInfo = res.data;
          this.$store.commit("setUserInfoValue", this.userInfo);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({ method: "get", url: "user_get_bank" }).then((res) => {
        if (res.code === 200) {
          const d = res.data || {};
          this.isBank = !!(
            d.is_bank === true ||
            d.is_bank === 1 ||
            d.is_bank === "1" ||
            (d.info && (d.info.bankid || d.info.bankinfo))
          );
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
  activated() {
    if (localStorage.getItem("token")) {
      this.getUserBankInfo();
    }
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000000;
}
.cell-card {
  background: #141414;
  border-radius: 16px;
  margin: 24px;
  overflow: hidden;
}
.cell-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 34px 28px;
  border-bottom: 1px solid rgba(201,168,76,0.2);
  font-size: 30px;
  color: #c9a84c;
  &:last-child {
    border-bottom: none;
  }
  .right {
    display: flex;
    align-items: center;
  }
  .desc {
    margin-right: 10px;
    color: #979799;
    font-size: 28px;
  }
  .avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
    background: #141414;
  }
}
.avatarbox {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #141414;
  color: #000;
}
.avatarbox .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px;
  border-bottom: 1px solid #000000;
  font-size: 30px;
}
.avatarbox .title .text {
  font-weight: 600;
}
.avatarbox .title .btnok {
  color: #c9a84c;
  font-weight: 700;
}
.avatar-list {
  flex: 1;
  overflow-y: auto;
  padding: 24px 10px 40px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-list .van-image {
  width: 110px;
  height: 110px;
  margin: 14px;
  border: 4px solid transparent;
  border-radius: 50%;
  box-sizing: border-box;
}
.avatar-list .van-image.choose {
  border-color: #c9a84c;
}
</style>
